import React from 'react';
interface Trade {
  market: string;
  side: 'Buy' | 'Sell';
  type: string;
  price: string;
  quantity: string;
  dateTime: string;
  leverage: string;
}
const mockTrades: Trade[] = [{
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Limit',
  price: '95,790.6',
  quantity: '0.00082670',
  dateTime: '1/15/26 11:35 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Sell',
  type: 'Market',
  price: '91,772.5',
  quantity: '0.00115416',
  dateTime: '12/12/25 4:18 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Market',
  price: '93,487.8',
  quantity: '0.00115416',
  dateTime: '12/11/25 10:31 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Market',
  price: '93,463.7',
  quantity: '0.00186441',
  dateTime: '12/11/25 10:31 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Sell',
  type: 'Market',
  price: '90,992.5',
  quantity: '0.00186441',
  dateTime: '12/8/25 11:32 PM',
  leverage: '10x'
}];
export function TradesTable() {
  if (mockTrades.length === 0) {
    return <div className="flex flex-col items-center justify-center h-full py-16" data-id="element-1758">
        <div className="w-12 h-12 rounded-full bg-background-elevated flex items-center justify-center mb-3" data-id="element-1759">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-text-tertiary" data-id="element-1760">
            <path d="M3 3v18h18" data-id="element-1761" />
            <path d="M7 12l3-3 4 4 5-5" data-id="element-1762" />
          </svg>
        </div>
        <p className="text-sm text-text-secondary" data-id="element-1763">No trades yet.</p>
      </div>;
  }
  return <div className="h-full overflow-auto" data-id="element-1764">
      <table className="w-full" data-id="element-1765">
        <thead className="sticky top-0 bg-background-secondary z-10" data-id="element-1766">
          <tr className="border-b border-border-subtle" data-id="element-1767">
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1768">
              Market
            </th>
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1769">
              Side
            </th>
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1770">
              Type
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1771">
              Price
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1772">
              Quantity
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1773">
              Date & Time
            </th>
          </tr>
        </thead>
        <tbody data-id="element-1774">
          {mockTrades.map((trade, idx) => <tr key={idx} className="border-b border-border-subtle hover:bg-background-elevated transition-colors" data-id="element-1775">
              <td className="px-4 py-3" data-id="element-1776">
                <div className="flex items-center gap-2" data-id="element-1777">
                  <img src="https://cryptologos.cc/logos/bitcoin-btc-logo.svg" alt="BTC" className="w-5 h-5" data-id="element-1778" />
                  <span className="font-medium text-text-primary" data-id="element-1779">
                    {trade.market}
                  </span>
                  <span className="text-xs text-text-tertiary bg-background-elevated px-1.5 py-0.5 rounded" data-id="element-1780">
                    {trade.leverage}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3" data-id="element-1781">
                <span className={`text-sm font-medium ${trade.side === 'Buy' ? 'text-success' : 'text-danger'}`} data-id="element-1782">
                  {trade.side}
                </span>
              </td>
              <td className="px-4 py-3" data-id="element-1783">
                <span className="text-sm text-text-primary" data-id="element-1784">{trade.type}</span>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1785">
                <div className="font-mono text-sm text-text-primary" data-id="element-1786">
                  {trade.price}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1787">USD</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1788">
                <div className="font-mono text-sm text-text-primary" data-id="element-1789">
                  {trade.quantity}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1790">BTC</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1791">
                <span className="text-sm text-text-secondary" data-id="element-1792">
                  {trade.dateTime}
                </span>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}